import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { 
  Paper,
  TextField,
  Button,
  CircularProgress,
  Box,
} from '@material-ui/core';
import useStyles from './style';

// const files = [
//   'https://documents-fintcore.s3.us-west-2.amazonaws.com/company/undefinedtmp/1745344752462.65759.jpeg',
//   'https://documents-fintcore.s3.us-west-2.amazonaws.com/company/undefinedtmp/1745344940099.67769.pdf',
//   'https://documents-fintcore.s3.us-west-2.amazonaws.com/company/undefinedtmp/1745344752462.65759.jpeg',
//   'https://documents-fintcore.s3.us-west-2.amazonaws.com/company/undefinedtmp/1745344940099.67769.pdf',
// ];

const MessageEdit = (props) => {
  const {
    message,
    onEdit,
    setIsEditMessage,
    setMessages,
  } = props;
  const classes = useStyles();
  const [isSubmittingEdit, setIsSubmittingEdit] = useState(false);
  const [editMessageText, setEditMessageText] = useState('');


  const handleEditSubmit = async () => {
    if (!editMessageText?.trim() || !onEdit) return;
    setIsSubmittingEdit(true);

    try {
      await onEdit(editMessageText, message?.id).then((updatedMessage) => {
        setMessages((prev) =>
          prev.map((msg) =>
            msg.id === message?.id ? updatedMessage : msg,
          ),
        );
      });
      setIsEditMessage(false);
      setEditMessageText('');
    } catch (error) {
      console.error('Error editing message:', error);
    } finally {
      setIsSubmittingEdit(false);
    }
  };

  const handleEditCancel = () => {
    setIsEditMessage(false);
    setEditMessageText('');
  };

  useEffect(() => {
    setEditMessageText(message?.text);
  }, [message]);

  return (
    <Box className={classes.editContainer}>
      <Paper 
        elevation={0} 
        className={`${classes.messageBubble} ${message?.user === 'user' ? 'user' : ''}`}
      >
        <TextField
          fullWidth
          multiline
          value={editMessageText ?? ''}
          onChange={(e) => {
            setEditMessageText(e.target.value);
          }}
          variant="standard"
          className={classes.editField}
          autoFocus
          InputProps={{
            classes: {
              input: classes.editInput,
            },
          }}
        />
        
        {/* Botón de tres puntos (solo si hay eventos) */}
        
      </Paper>
      
      <Box className={classes.editActions}>
        <Button
          size="small"
          onClick={handleEditCancel}
          className={classes.editButton}
        >
          Cancelar
        </Button>
        <Button
          size="small"
          color="primary"
          onClick={handleEditSubmit}
          className={classes.editButton}
          disabled={isSubmittingEdit}
        >
          {isSubmittingEdit ? (
            <>
              <CircularProgress size={12} style={{
                marginRight: '7px',
              }} />
              Guardando
            </>
          ) : (
            'Guardar'
          )}
        </Button>
      </Box>
    </Box>
  );
};

MessageEdit.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    text: PropTypes.string.isRequired,
    user: PropTypes.string.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  setIsEditMessage: PropTypes.func.isRequired,
  setMessages: PropTypes.func.isRequired,
};

export default MessageEdit;
